export const FFS_PREFIX = 'rcv-app';
export const FFS_FEATURE_KEY = 'rcv';
export const FFS_IDENTIFY_INFO_KEY = 'ffsIdentifyInfo';

export const FFS_LEVEL_PREFIX = {
    APP: 'rcv-app.app',
    USER: 'rcv-app.user',
};

export const FEATURE_FLAG_PRIORITY = {
    FFS: 2,
};
